"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const form_ejs_1 = require("./form.ejs");
const builder_ejs_1 = require("./builder.ejs");
exports.default = { form: form_ejs_1.default, builder: builder_ejs_1.default };
